<app-shared-dialog
  [title]="title"
  [options]="dialogOptions"
  (confirm)="submit()"
  (cancel)="onCancel()"
>
  <div class="policy-dialog" data-testid="mfa-policy-dialog">
    <ui-auth-error-banner *ngIf="error" [error]="error"></ui-auth-error-banner>

    <p class="policy-dialog__notice" *ngIf="!canEdit" data-testid="mfa-policy-read-only">
      {{ 'settings_security.policy.read_only' | translate }}
    </p>

    <!-- The confirmation, not a second dialog: the form below is disabled
         while this is up, so what was confirmed is what gets saved. -->
    <p
      class="policy-dialog__confirm"
      *ngIf="confirming"
      data-testid="mfa-policy-confirm"
    >
      {{
        'settings_security.policy.require_confirm' | translate: { count: coverageGap }
      }}
    </p>

    <form class="policy-dialog__form" [formGroup]="policyForm">
      <ui-form-field
        [id]="'mfa-policy-mode'"
        testId="mfa-policy-mode"
        type="select"
        formControlName="policy"
        [options]="policyOptions"
        [label]="'settings_security.policy.mode' | translate"
      ></ui-form-field>

      <ui-form-field
        [id]="'mfa-policy-grace-days'"
        testId="mfa-policy-grace-days"
        type="number"
        formControlName="grace_days"
        [min]="0"
        [max]="365"
        [step]="1"
        [label]="'settings_security.policy.grace_days' | translate"
      ></ui-form-field>

      <p class="policy-dialog__help">
        {{ 'settings_security.policy.grace_days_help' | translate }}
      </p>

      <!-- The text is a sibling, not a wrapping <label>: `ui-checkbox` already
           has one around its input, and nesting labels is invalid. `ariaLabel`
           names the control. -->
      <div class="policy-dialog__toggle">
        <ui-checkbox
          [checked]="emailOtpEnabled"
          [disabled]="!canEdit || confirming"
          [ariaLabel]="'settings_security.policy.email_otp' | translate"
          (changed)="onEmailOtpChange($event.checked)"
        ></ui-checkbox>
        <span data-testid="mfa-policy-email-otp">
          {{ 'settings_security.policy.email_otp' | translate }}
        </span>
      </div>

      <p class="policy-dialog__help">
        {{ 'settings_security.policy.email_otp_help' | translate }}
      </p>
    </form>

    <p
      class="policy-dialog__help"
      *ngIf="willLockOutUnenrolled && !confirming"
      data-testid="mfa-policy-will-lock-out"
    >
      {{ 'settings_security.policy.require_hint' | translate }}
    </p>
  </div>
</app-shared-dialog>
